import { render } from "./Facebook.vue?vue&type=template&id=56f87a85&scoped=true"
import script from "./Facebook.vue?vue&type=script&lang=js"
export * from "./Facebook.vue?vue&type=script&lang=js"

import "./Facebook.vue?vue&type=style&index=0&id=56f87a85&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f87a85"]])

export default __exports__